<template>
  <div class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2'">
    <div class="ss-gm">
      <set-card id="web" :title="$t('settings_shell.appearance.web_title')" :desc="$t('settings_shell.appearance.web_d')">
        <div class="ss-slots">
          <set-image-slot path="logo" :title="$t('logo')" :hint="$t('settings_shell.appearance.hint_logo')" />
          <set-image-slot path="header" :title="$t('header')" :hint="$t('settings_shell.appearance.hint_header')" />
          <set-image-slot path="restoran_image" :title="$t('restaurant_image')" :hint="$t('settings_shell.appearance.hint_restaurant')" />
        </div>
      </set-card>
      <set-card id="mob" :title="$t('settings_shell.appearance.mob_title')" :desc="$t('settings_shell.appearance.mob_d')">
        <div class="ss-slots">
          <set-image-slot path="logo_mob_header" :title="$t('settings_shell.appearance.title_mob_header')" :hint="$t('settings_shell.appearance.hint_mob_header')">
            <set-field path="mob.baner_link_header" :label="$t('header_banner_link')" placeholder="https://" />
          </set-image-slot>
          <set-image-slot path="logo_mob_footer" :title="$t('settings_shell.appearance.title_mob_footer')" :hint="$t('settings_shell.appearance.hint_mob_footer')">
            <set-field path="mob.baner_link_footer" :label="$t('footer_banner_link')" placeholder="https://" />
          </set-image-slot>
          <set-image-slot path="logo_mob_restoran" :title="$t('settings_shell.appearance.mob_list')" :hint="$t('settings_shell.appearance.hint_mob_list')">
            <set-field path="mob.baner_link_restoran" :label="$t('restaurant_banner_link')" placeholder="https://" />
          </set-image-slot>
        </div>
      </set-card>
    </div>
    <aside class="ss-gs">
      <set-card id="pregled" :title="$t('settings_shell.appearance.preview')" :desc="$t('settings_shell.appearance.preview_d')" tone="sim">
        <ui-segment v-model="tab" :options="tabs" :label="$t('settings_shell.appearance.preview')" />
        <div class="ss-pv">
          <div v-if="tab === 'web'" class="ss-pv-web">
            <div class="ss-pv-bar"><i></i><i></i><i></i></div>
            <div class="ss-pv-hd" :class="{ 'is-has': form.header }" :style="bg('header')">
              <span class="ss-pv-logo" :class="{ 'is-has': form.logo }" :style="bg('logo')">
                <v-icon v-if="!form.logo" size="18">mdi-image-outline</v-icon>
              </span>
              <b>{{ restaurantName }}</b>
            </div>
            <div class="ss-pv-body">
              <div class="ss-pv-ph" :class="{ 'is-has': form.restoran_image }" :style="bg('restoran_image')">
                <v-icon v-if="!form.restoran_image" size="22">mdi-image-outline</v-icon>
              </div>
              <div class="ss-pv-tx"><i></i><i></i><i class="s"></i></div>
            </div>
          </div>
          <div v-else class="ss-pv-mob">
            <div class="ss-pv-mt"><span></span></div>
            <div class="ss-pv-mb" :class="{ 'is-has': form.logo_mob_header }" :style="bg('logo_mob_header')">
              <em v-if="!form.logo_mob_header">{{ $t("settings_shell.appearance.title_mob_header") }}</em>
            </div>
            <div class="ss-pv-li">
              <span class="ss-pv-lp" :class="{ 'is-has': form.logo_mob_restoran }" :style="bg('logo_mob_restoran')"></span>
              <span class="ss-pv-ln"><i></i><i class="s"></i></span>
            </div>
            <div class="ss-pv-li">
              <span class="ss-pv-lp"></span>
              <span class="ss-pv-ln"><i></i><i class="s"></i></span>
            </div>
            <div class="ss-pv-mf" :class="{ 'is-has': form.logo_mob_footer }" :style="bg('logo_mob_footer')">
              <em v-if="!form.logo_mob_footer">{{ $t("settings_shell.appearance.title_mob_footer") }}</em>
            </div>
          </div>
        </div>
      </set-card>
    </aside>
  </div>
</template>

<script>
import SetCard from "../parts/SetCard.vue";
import SetField from "../parts/SetField.vue";
import SetImageSlot from "../parts/SetImageSlot.vue";

/** Osnovno › Izgled: slike za web i mobilnu aplikaciju (sa linkovima banera) i pregled prije snimanja. */
export default {
  name: "ScreenAppearance",
  components: { SetCard, SetField, SetImageSlot },
  inject: { ctl: "settingsCtl" },
  data: () => ({ tab: "web" }),
  computed: {
    form() {
      return this.ctl.form;
    },
    tabs() {
      return [
        { value: "web", label: this.$t("settings_shell.appearance.tab_web") },
        { value: "mob", label: this.$t("settings_shell.appearance.tab_mob") },
      ];
    },
    restaurantName() {
      return this.toLatin((this.ctl.restaurant && this.ctl.restaurant.name) || "");
    },
  },
  methods: {
    bg(path) {
      const name = this.form[path];
      return name ? { backgroundImage: `url("${this.ctl.imageUrl(name)}")` } : {};
    },
  },
};
</script>
